import { handleActions } from 'redux-actions';
import { passwordVerifyError } from './action';
import { FormValues } from './view';

interface State {
  errors: Partial<FormValues>;
}

const initialState: State = {
  errors: {},
};

const reducer = handleActions(
  {
    [String(passwordVerifyError)]: (state, { payload }) => {
      return { ...state, errors: payload.errors };
    },
  },
  initialState,
);

export default reducer;
